<template>
  <div>
      <a-button type="primary"   @click="openCamera">识别</a-button>
    <!-- <button @click="openCamera">图片</button> -->
    <input
      ref="cameraInput"
      type="file"
      accept="image/*"
      capture="environment"
      style="display: none"
      @change="handlePhoto"
    />
    <!-- <img v-if="photoUrl" :src="photoUrl" alt="照片预览" style="max-width: 100%; margin-top: 16px;" /> -->
  </div>
</template>

<script>
import axios from 'axios';
  import { postAction } from '@/api/manage'

export default {
  data() {
    return {
      photoUrl: '', // 用于照片预览
      ocrData: {},
    };
  },
  methods: {
    openCamera() {
      this.$refs.cameraInput.click();
    },
    async handlePhoto(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.photoUrl = URL.createObjectURL(file); // 显示照片预览
      const formData = new FormData();
      formData.append('multipartFile', file);
      try {
        postAction('/patient/ocr/idCard', formData).then(data => {
            this.ocrData = data;
            this.callback();
          }).catch(e => {
            this.$message.error('识别失败: ' + e.message);
        });
      } catch (err) {
        alert('上传失败');
      }
       // 关键：重置 input 的值，保证每次都能触发 change
      e.target.value = '';
    },
     callback(){
         this.$emit('data-update',  this.ocrData);
      },
  },
};
</script>